import { ChevronDownIcon } from 'lucide-react';

import { cn } from '@src/design-system/helpers';
import { inputVariants } from '@src/design-system/input';
import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandList,
} from '@src/design-system/command';
import { useGetAllLocales } from '@shared/services/get-all-locales';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { SelectContentCountry } from './memoized-options';
import type { TLocale } from '@shared/types/locale';

export function CountryField({
  value = '',
  isInModal = false,
  onSelect,
  isSelected,
  placeholder = 'Select country',
  className,
}: {
  value?: string;
  isInModal?: boolean;
  onSelect?: (country: TLocale) => void;
  isSelected?: (country: TLocale) => boolean;
  placeholder?: string;
  className?: string;
}) {
  const { data: countries } = useGetAllLocales();
  const label = countries?.find(
    (c) => c.name === value || c.code === value
  )?.name;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          inputVariants(),
          'w-full cursor-pointer flex justify-between items-center',
          className,
        )}
      >
        {value ? (
          <span className='text-sm'>{label}</span>
        ) : (
          <span className='text-sm text-gray-500'>{placeholder}</span>
        )}

        <ChevronDownIcon size={20} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        isInModal={isInModal}
        style={{
          width: 'var(--radix-dropdown-menu-trigger-width)',
          minWidth: 200,
        }}
        align='start'
        className='p-2 z-10'
      >
        <Command>
          <CommandInput placeholder='Search by name...' />
          <CommandList>
            <CommandEmpty>No results found.</CommandEmpty>
            <SelectContentCountry
              isSelected={isSelected}
              onSelect={onSelect}
              countries={countries}
            />
          </CommandList>
        </Command>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
